import { render } from "./UserAddView.vue?vue&type=template&id=03b41ce4"
import script from "./UserAddView.vue?vue&type=script&lang=js"
export * from "./UserAddView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__